import {Bento, Grid, Link, SectionIntro, Text} from '@primer/react-brand'
import {analyticsEvent} from '../../../../lib/analytics'
import {Image} from '../../../../components/Image/Image'
import {CustomerStoryBento} from './CustomerStory'

export default function EnterpriseSection() {
  return (
    <section id="enterprise" className="lp-Section lp-Section--level-1">
      <Grid className="lp-Section-container--centerUntilMedium lp-Grid--noRowGap">
        <Grid.Column span={12}>
          <SectionIntro fullWidth align="center" className="lp-SectionIntro">
            <SectionIntro.Label size="large" className="lp-Label--section">
              Enterprise-grade
            </SectionIntro.Label>
            <SectionIntro.Heading size="2" weight="semibold">
              The competitive advantage developers ask for by name
            </SectionIntro.Heading>
          </SectionIntro>
        </Grid.Column>

        <Grid.Column span={12}>
          <Bento className="Bento Bento--inset">
            <Bento.Item
              columnSpan={{xsmall: 12, medium: 6, large: 7}}
              rowSpan={{xsmall: 4, small: 3, medium: 4, large: 5, xlarge: 5}}
              visualAsBackground
            >
              <Bento.Content padding={{xsmall: 'normal', xlarge: 'spacious'}}>
                <Bento.Heading as="h3" size="3" weight="semibold">
                  Proven to increase developer productivity and accelerate the pace of software development.
                </Bento.Heading>
                <Link
                  href="https://github.blog/2022-09-07-research-quantifying-github-copilots-impact-on-developer-productivity-and-happiness/"
                  size="large"
                  variant="default"
                  {...analyticsEvent({
                    action: 'research_blog',
                    tag: 'link',
                    context: 'developer_productivity',
                    location: 'enterprise_ready',
                  })}
                >
                  Read the research
                </Link>
              </Bento.Content>
              <Bento.Visual>
                <Image src="/images/modules/site/copilot/enterprise-1.jpg" alt="" width="724" height="540" />
              </Bento.Visual>
            </Bento.Item>

            <Bento.Item
              columnSpan={{xsmall: 12, medium: 6, large: 5}}
              rowSpan={{xsmall: 3, small: 3, medium: 4, large: 5, xlarge: 5}}
              visualAsBackground
            >
              <Bento.Content
                padding={{xsmall: 'normal', xlarge: 'spacious'}}
                verticalAlign="end"
                className="lp-Bento-lastChildNoMarginBottom"
              >
                <Bento.Heading as="h3" size="display" className="is-sansSerifAlt lp-Speed-stat">
                  55%
                </Bento.Heading>
                <Text as="p" size="400" weight="medium" variant="muted" style={{marginBottom: '0'}}>
                  Faster coding
                </Text>
              </Bento.Content>
              <Bento.Visual>
                <Image
                  src="/images/modules/site/copilot/enterprise-2.webp"
                  className="object-pos-0"
                  alt=""
                  width="492"
                  height="540"
                />
              </Bento.Visual>
            </Bento.Item>

            <Bento.Item
              columnSpan={{xsmall: 12, medium: 6, large: 5}}
              rowSpan={{xsmall: 3, small: 3, medium: 4, large: 4, xlarge: 5}}
              visualAsBackground
            >
              <Bento.Content
                padding={{xsmall: 'normal', xlarge: 'spacious'}}
                verticalAlign="end"
                className="lp-Bento-lastChildNoMarginBottom"
              >
                <Bento.Heading as="h3" size="4" weight="semibold">
                  Designed by leaders in AI so you can build with confidence.
                </Bento.Heading>
              </Bento.Content>
              <Bento.Visual>
                <Image
                  src="/images/modules/site/copilot/enterprise-3.webp"
                  className="object-pos-0"
                  alt=""
                  width="492"
                  height="540"
                />
              </Bento.Visual>
            </Bento.Item>

            <Bento.Item
              columnSpan={{xsmall: 12, medium: 6, large: 7}}
              rowSpan={{xsmall: 3, small: 3, medium: 4, large: 4, xlarge: 5}}
              visualAsBackground
            >
              <Bento.Content padding={{xsmall: 'normal', xlarge: 'spacious'}}>
                <Bento.Heading as="h3" size="3" weight="semibold">
                  Committed to your privacy, security, and trust.
                </Bento.Heading>
                <Link
                  href="/trust-center"
                  size="large"
                  variant="default"
                  {...analyticsEvent({
                    action: 'trust_center',
                    tag: 'link',
                    context: 'privacy_tile',
                    location: 'enterprise_ready',
                  })}
                >
                  Visit the GitHub Copilot Trust Center
                </Link>
              </Bento.Content>
              <Bento.Visual>
                <Image src="/images/modules/site/copilot/enterprise-4.jpg" alt="" width="724" height="540" />
              </Bento.Visual>
            </Bento.Item>

            <CustomerStoryBento />
          </Bento>
        </Grid.Column>
      </Grid>
    </section>
  )
}

try{ EnterpriseSection.displayName ||= 'EnterpriseSection' } catch {}